<div class="glass-card rounded-4 p-0 mb-3 shadow-sm overflow-hidden">
  <div class="accordion accordion-flush">

    <div class="accordion-item bg-transparent border-0">

      <!-- HEADER -->
      <h2 class="accordion-header">
        <button
          class="accordion-button bg-transparent px-3 py-3"
          :class="{ collapsed: !is_open }"
          type="button"
          @click="toggle"
          :aria-expanded="is_open.toString()"
        >
          <!-- HEADER UI -->
          <div class="d-flex align-items-center w-100 gap-3">

            <!-- Avatar -->
            <div class="member-avatar d-flex align-items-center justify-content-center">
              <span class="fw-bold text-white text-xs">{{ initials }}</span>
            </div>

            <!-- Name & Role -->
            <div class="flex-grow-1">
              <div class="fw-semibold">
                {{ full_name }}
              </div>
              <div class="text-muted text-xs">
                {{ role }}
              </div>
            </div>

            <!-- Status -->
            <div class="d-flex align-items-center gap-2">
              <span class="status-dot" :class="status_dot_class"></span>
              <span class="text-muted text-xs">
                {{ status_label }}
              </span>
            </div>

          </div>
        </button>
      </h2>

      <!-- BODY -->
      <div
        class="accordion-collapse collapse"
        :class="{ show: is_open }"
      >
        <div class="accordion-body px-3 pb-3 pt-2">
          <div class="d-flex flex-column gap-2">

            <div v-if="hours" class="doc-item rounded-4 px-3 py-2 d-flex gap-2">
              <i class="bi bi-clock-fill text-primary"></i>
              <div>
                <p class="text-muted text-xxs mb-1">Hours</p>
                <p class="text-xs mb-0">{{ hours }}</p>
              </div>
            </div>

            <div v-if="phone" class="doc-item rounded-4 px-3 py-2 d-flex gap-2">
              <i class="bi bi-telephone-fill text-primary"></i>
              <div>
                <p class="text-muted text-xxs mb-1">Phone</p>
                <p class="text-xs mb-0">{{ phone }}</p>
              </div>
            </div>

            <div v-if="email" class="doc-item rounded-4 px-3 py-2 d-flex gap-2">
              <i class="bi bi-envelope-fill text-primary"></i>
              <div>
                <p class="text-muted text-xxs mb-1">Email</p>
                <p class="text-xs mb-0">{{ email }}</p>
              </div>
            </div>

            <div v-if="address" class="doc-item rounded-4 px-3 py-2 d-flex gap-2">
              <i class="bi bi-geo-alt-fill text-primary"></i>
              <div>
                <p class="text-muted text-xxs mb-1">Address</p>
                <p class="text-xs mb-0">{{ address }}</p>
              </div>
            </div>

            <div v-if="website && website !== 'N/A'" class="doc-item rounded-4 px-3 py-2 d-flex gap-2">
              <i class="bi bi-globe2 text-primary"></i>
              <div>
                <p class="text-muted text-xxs mb-1">Website</p>
                <a
                  :href="safe_website"
                  target="_blank"
                  class="text-primary text-xs text-decoration-none"
                >
                  {{ website }}
                </a>
              </div>
            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</div>
